import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import { ReportType } from '@ddt-web/pdf-utils';
import * as get from 'lodash/get';

import { DisclosureComponent } from '../../disclaimers/disclosure-component';
import { HeadingComponent, HeadingLevel } from '../../heading/heading-component';
import { FundPerformancePanelsHelper } from '../../helpers/fund-performance/fund-performance-panels-helper';

export class LoadAdjustedReturnsComponent extends BusinessComponent {
	private loadAdjustedTab: TabData;

	constructor(
		name: string,
		public dataComponentId: string,
		private mode?: ReportType,
		private loadAdjDisclaimer2Key: string = 'PDF_LOAD_ADJUSTED_DISCLAIMER_2',
		private shouldReduceSpacing: boolean = false,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		const isComponentDataSuccessful = componentData && componentData.success;
		this.loadAdjustedTab = isComponentDataSuccessful && get(componentData, 'tabs[3]');

		return TabUtil.isTabValid(this.loadAdjustedTab);
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		if (this.isComponentDataVisible(componentData)) {
			return [
				new HeadingComponent('PDF_LOAD_ADJUSTED_RET_H3', 'QUARTERLY RETURNS - LOAD ADJUSTED(%)***', HeadingLevel.H3),
				...FundPerformancePanelsHelper.getAsOfDatePanel(this.loadAdjustedTab, {}, this.shouldReduceSpacing),
				...FundPerformancePanelsHelper.getFundPerformancePanels(this.loadAdjustedTab, contentSvc, {}, this.mode, this.shouldReduceSpacing),
				new DisclosureComponent('PDF_LOAD_ADJUSTED_DISCLAIMER_1', '* Annualized', {}, { paddingTop: 15 }),
				new DisclosureComponent(this.loadAdjDisclaimer2Key, '*** For Mutual Funds only', {}, { paddingBottom: 15 })
			];
		}
		return [];
	}
}
